namespace $ {

	/** Diagnostic only: validate a future query snapshot without opening row payloads. */
	export class $shm_hitalama_benchmarks_goods_signature extends $mol_object {
		@ $mol_mem_key
		lands( lands: readonly $giper_baza_land[] ) {
			const stamps: ( string | null )[] = []
			for( let from = 0; from < lands.length; from += 32 ) {
				stamps.push( ...this.batch([ lands, from, Math.min( from + 32, lands.length ) ]) )
			}
			return stamps
		}

		@ $mol_mem_key
		batch( key: readonly [ readonly $giper_baza_land[], number, number ] ) {
			const [ lands, from, until ] = key
			return this.$.$mol_wire_race( ...lands.slice( from, until ).map( land=> ()=> this.land( land ) ) )
		}

		@ $mol_mem_key
		land( land: $giper_baza_land ): string | null {
			land.sync()
			land.secret() // A cached query must not bypass current read rights.
			// Tines can depend on other lands. Do not declare such a snapshot valid.
			if( land._sand.has( $giper_baza_land_root.tine.str ) ) return null
			const hashes: string[] = []
			for( const gift of land._gift.values() ) hashes.push( gift.hash().str )
			// These are reactive dictionaries. Replacements (including late remote
			// edits below the maximum face clock) invalidate the signature channel.
			for( const peers of land._sand.values() ) for( const sands of peers.values() ) {
				for( const sand of sands.values() ) {
					if( !sand.encoded() ) return null
					hashes.push( sand.hash().str )
				}
			}
			return $giper_baza_link.hash_str( JSON.stringify([ land.link().str, hashes.sort() ]) ).str
		}
	}

}
